import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import Title from './Title'

class TitleBinder extends Component{

  render(){
    return <Title></Title>
  }
}
export default TitleBinder



// WEBPACK FOOTER //
// ./src/topModule/TitleBinder.js